//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faSackDollar,
  faCoins,
  faGlobeAsia,
} from '@fortawesome/pro-light-svg-icons';

import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';
import { newMediaTypes } from '@motionelements/core/src/helpers/newMediaTypes.js';
import newMediaTypesMixin from '@/components/mixins/new-mediatypes.mixin.js';

export default {
  name: 'submission-channel',
  scrollToTop: true,
  mixins: [newMediaTypesMixin, featureFlagMixin],
  async asyncData({ params, redirect }) {
    const channel = newMediaTypes.find(({ link }) => link.includes(params.channel));
    if (channel) {
      const channelId = channel.id;

      return { channelId };
    }
    redirect('/call-for-submission');
  },
  components: {
    SubmissionHero: () => import('@/components/submission/SubmissionHero.vue'),
    SubmissionCategories: () => import('@/components/submission/SubmissionCategories.vue'),
    SpecificationsSection: () => import('@/components/submission/SpecificationsSection.vue'),
    CanvaTemplatesBanner: () => import('@/components/submission/CanvaTemplatesBanner.vue'),
    HomeBenefits: () => import('@/components/home-page/HomeBenefits.vue'),
    SubmissionSteps: () => import('@/components/submission/SubmissionSteps.vue'),
    DiscoverMore: () => import('@/components/submission/DiscoverMore.vue'),
    HomeFaqs: () => import('@/components/home-page/HomeFaqs.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
  },
  data() {
    return {
      benefits: [
        {
          icon: faSackDollar,
          color: 'aqua',
          heading: this.$t(this.$wbr('contributor.submission.benefits_1_heading')),
          text: this.$t(this.$wbr('contributor.submission.benefits_1_text')),
        },
        {
          icon: faCoins,
          color: 'blue',
          heading: this.$t(this.$wbr('contributor.submission.benefits_2_heading')),
          text: this.$t(this.$wbr('contributor.submission.benefits_2_text')),
        },
        {
          icon: faGlobeAsia,
          color: 'pink',
          heading: this.$t(this.$wbr('contributor.submission.benefits_3_heading')),
          text: this.$t(this.$wbr('contributor.submission.benefits_3_text')),
        },
      ],
    };
  },
  computed: {
    pageTitle() {
      return _.get(this.mediaTypes[this.channelId], 'heading');
    },
    faqType() {
      return _.get(this.mediaTypes[this.channelId], 'faqType') || `cfs_${this.channelId}_template`;
    },
    pageDescription() {
      return this.$t('contributor.submission.submission_subheading_{media_type}', {
        media_type: _.get(this.mediaTypes[this.channelId], 'heading'),
      });
    },
    breadcrumbList() {
      const mediaType = newMediaTypes.find(({ id }) => id === this.channelId);
      return [
        {
          name: this.$t('term.contributors'),
          link: this.$link('/contributors').fullPath(),
        },
        {
          name: this.$t('contributor.submission.call_for_submission'),
          link: this.$link('/call-for-submission').fullPath(),
        },
        {
          name: this.pageTitle,
          link: this.$link(_.get(mediaType, 'link')).url(),
          active: true,
        },
      ];
    },
  },
};
